module.exports = __webpack_public_path__ + "img/Gray_Heron_2.170b54ff.png";